"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  titleAs: "h3",
  centeredTitle: true,
  headerFont: "xxl",
  headerIndent: 0,
  descriptionFont: "base_sans_bold",
  withBorder: true,
  titleColor: "main",
  descriptionColor: "main",
  bottomBorderColor: "main",
  noSpaceAfterHeader: false,
  withContainer: false
};
var SectionWithConfigurableHeader = function SectionWithConfigurableHeader(props) {
  var title = props.title,
    link = props.link,
    children = props.children,
    _props$titleAs = props.titleAs,
    titleAs = _props$titleAs === void 0 ? defaultProps.titleAs : _props$titleAs,
    _props$centeredTitle = props.centeredTitle,
    centeredTitle = _props$centeredTitle === void 0 ? defaultProps.centeredTitle : _props$centeredTitle,
    description = props.description,
    _props$headerFont = props.headerFont,
    headerFont = _props$headerFont === void 0 ? defaultProps.headerFont : _props$headerFont,
    _props$headerIndent = props.headerIndent,
    headerIndent = _props$headerIndent === void 0 ? defaultProps.headerIndent : _props$headerIndent,
    _props$noSpaceAfterHe = props.noSpaceAfterHeader,
    noSpaceAfterHeader = _props$noSpaceAfterHe === void 0 ? defaultProps.noSpaceAfterHeader : _props$noSpaceAfterHe,
    _props$descriptionFon = props.descriptionFont,
    descriptionFont = _props$descriptionFon === void 0 ? defaultProps.descriptionFont : _props$descriptionFon,
    _props$withBorder = props.withBorder,
    withBorder = _props$withBorder === void 0 ? defaultProps.withBorder : _props$withBorder,
    _props$titleColor = props.titleColor,
    titleColor = _props$titleColor === void 0 ? defaultProps.titleColor : _props$titleColor,
    _props$descriptionCol = props.descriptionColor,
    descriptionColor = _props$descriptionCol === void 0 ? defaultProps.descriptionColor : _props$descriptionCol,
    _props$bottomBorderCo = props.bottomBorderColor,
    bottomBorderColor = _props$bottomBorderCo === void 0 ? defaultProps.bottomBorderColor : _props$bottomBorderCo,
    additionalBlock = props.additionalBlock,
    mobileLinkButton = props.mobileLinkButton,
    _props$withContainer = props.withContainer,
    withContainer = _props$withContainer === void 0 ? defaultProps.withContainer : _props$withContainer;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var border = {
    borderBottomWidth: description ? "2px" : 0,
    borderBottomStyle: "solid",
    borderBottomColor: bottomBorderColor
  };
  var headerContent = __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: _objectSpread({
      textAlign: centeredTitle ? "center" : ["center", null, "left"],
      display: additionalBlock ? "flex" : description ? "inline-block" : "block",
      justifyContent: "space-between",
      font: headerFont,
      mb: description || noSpaceAfterHeader ? 0 : link ? ["200px"] : ["s8", null, null, "s10", null, null],
      pr: description ? [0, null, "s13"] : 0,
      pb: description ? "s5" : 0,
      pl: headerIndent,
      color: titleColor
    }, withBorder && border),
    as: titleAs
  }, additionalBlock ? __jsx(_Box["default"], null, title) : title, additionalBlock && __jsx(_Box["default"], null, additionalBlock)), description && __jsx(_Box["default"], {
    sx: {
      font: descriptionFont,
      color: descriptionColor,
      mb: "s10",
      mt: "s5"
    }
  }, description), link && __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: "s_sans",
      mt: noSpaceAfterHeader ? "s5" : 0,
      mb: ["s8", null, null, "s10", null, null],
      color: "main",
      textDecoration: "underline",
      cursor: "pointer"
    }
  }, __jsx(Link, {
    route: "category-page",
    params: {
      url: (link === null || link === void 0 ? void 0 : link.url.indexOf("/")) === 0 ? link.url.replace("/", "") : link.url
    }
  }, __jsx(_LinkRaw["default"], {
    title: link.name
  }, link.name))));
  return withContainer ? __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Container["default"], null, headerContent), children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "") : __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, headerContent, " ", children, mobileLinkButton ? __jsx(_Container["default"], null, mobileLinkButton) : "");
};
var _default = SectionWithConfigurableHeader;
exports["default"] = _default;